import script from "./DataTableColumnSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTableColumnSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./DataTableColumnSettingsModal.vue?vue&type=style&index=0&id=006b3ffe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006b3ffe"]])

export default __exports__